import { PointsTransactionSchema } from "@redotech/redo-fulfillment-outbound-labels-common/points";
import { AdvancedFilterInputSchema } from "@redotech/redo-model/fulfillments/fulfillment-group-summary-input";
import { PaginationCursorSchema } from "@redotech/redo-views-common/table";
import * as z from "zod";

export const getPointsTransactions = {
  name: "getPointsTransactions" as const,
  input: AdvancedFilterInputSchema.extend({
    pageNumber: z.number(),
    pageSize: z.number(),
    paginationCursor: PaginationCursorSchema.nullish(),
  }),
  output: z.object({
    transactions: z.array(PointsTransactionSchema),
    paginationCursor: PaginationCursorSchema.nullish(),
  }),
};
